import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShop } from '../context/ShopContext';
import { 
  ShieldCheck, 
  HelpCircle, 
  Gift, 
  Briefcase, 
  CreditCard,
  MapPin, 
  Phone, 
  Mail, 
  Clock, 
  MessageCircle,
  FileText,
  RefreshCw,
  Truck,
  Award,
  Smartphone,
  Download
} from 'lucide-react';

export default function Footer() {
  const { 
    addToast, 
    storeSettings, 
    categories
  } = useShop();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    addToast(`Thank you for subscribing to updates!`, 'success');
    setEmail('');
  };

  const cleanWaNumber = String(storeSettings?.whatsapp || storeSettings?.phone || '').replace(/[^0-9]/g, '');

  return (
    <footer style={{
      backgroundColor: '#172337',
      color: '#ffffff',
      fontSize: '12px',
      borderTop: '1px solid #e0e0e0'
    }}>
      {/* Top Footer Columns */}
      <div className="container" style={{ padding: '40px 16px 30px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '28px'
        }}>
          
          {/* ABOUT */}
          <div>
            <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
              ABOUT M.L. JEWELLERS
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <Link to="/about" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  About Heritage & Legacy
                </Link>
              </li>
              <li>
                <Link to="/store-locator" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Showrooms & Store Locator
                </Link>
              </li>
              <li>
                <Link to="/live-rates" style={{ color: '#ffd700', textDecoration: 'none', fontWeight: 600 }}>
                  ● Live Bullion Gold & Silver
                </Link>
              </li>
              <li>
                <Link to="/policy/privacy" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Corporate Information
                </Link>
              </li>
            </ul>
          </div>

          {/* DEDICATED TOOLS & SERVICES */}
          <div>
            <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
              TOOLS & CLUBS
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <Link to="/wastage-calculator" style={{ color: '#38ef7d', textDecoration: 'none', fontWeight: 600 }}>
                  ⚖️ 0% Wastage Calculator
                </Link>
              </li>
              <li>
                <Link to="/wastage-rate-card" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  📋 24KT Wastage Rate Card
                </Link>
              </li>
              <li>
                <Link to="/b2b-club" style={{ color: '#ffe500', textDecoration: 'none', fontWeight: 600 }}>
                  👑 24KT B2B Wholesale Club
                </Link>
              </li>
              <li>
                <Link to="/calculator" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  🧮 Jewellery Price Calculator
                </Link>
              </li>
              <li>
                <Link to="/account" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  👤 Customer Dashboard & Orders
                </Link>
              </li>
            </ul>
          </div>

          {/* POPULAR CATEGORIES */}
          <div>
            <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
              POPULAR CATEGORIES
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <Link to="/bridal" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Royal Bridal Sets
                </Link>
              </li>
              <li>
                <Link to="/rings" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Diamond & Solitaire Rings
                </Link>
              </li>
              <li>
                <Link to="/necklaces" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Padmavati Kundan Necklaces
                </Link>
              </li>
              <li>
                <Link to="/bangles" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Temple Kadas & Bangles
                </Link>
              </li>
              <li>
                <Link to="/kitchenware" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Tri-Ply Heritage Kitchenware
                </Link>
              </li>
            </ul>
          </div>

          {/* HELP & POLICIES */}
          <div>
            <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
              POLICIES & HELP
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li>
                <Link to="/policy/shipping" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Insured Armored Delivery
                </Link>
              </li>
              <li>
                <Link to="/policy/return" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  15-Day Exchange & Returns
                </Link>
              </li>
              <li>
                <Link to="/policy/terms" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Terms & Bullion Conditions
                </Link>
              </li>
              <li>
                <Link to="/policy/privacy" style={{ color: '#ffffff', textDecoration: 'none' }}>
                  Privacy & Data Security
                </Link>
              </li>
            </ul>
          </div>

          {/* SOCIAL & CONTACT */}
          <div>
            <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
              MAIL US:
            </div>
            <div style={{ color: '#ffffff', lineHeight: 1.6, marginBottom: '12px' }}>
              {storeSettings?.storeName || 'M.L. Jewellers & Kitchenware'},<br />
              {storeSettings?.address || 'Gold Bazaar, Sarafa Market, India.'}<br />
              Phone: {storeSettings?.phone || '+91 98290 12345'}
            </div>
            {cleanWaNumber && (
              <a
                href={`https://wa.me/${cleanWaNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  backgroundColor: '#25D366',
                  color: '#ffffff',
                  padding: '5px 12px',
                  borderRadius: '2px',
                  textDecoration: 'none',
                  fontWeight: 600,
                  fontSize: '11px'
                }}
              >
                <MessageCircle size={14} /> WhatsApp Support
              </a>
            )}
          </div>

          {/* REGISTERED OFFICE & APP DOWNLOAD (Admin Customizable - Hidden by default) */}
          {(storeSettings?.showRegisteredOffice || storeSettings?.showAppDownloadBanner) && (
            <div>
              {storeSettings?.showRegisteredOffice && (
                <>
                  <div style={{ color: '#878787', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', fontSize: '12px' }}>
                    REGISTERED OFFICE:
                  </div>
                  <div style={{ color: '#ffffff', lineHeight: 1.6, marginBottom: '16px' }}>
                    {storeSettings?.registeredCompanyName || `${storeSettings?.storeName || 'M.L. Jewellers & Kitchenware'} Private Limited`},<br />
                    {storeSettings?.cinNumber && <>CIN: {storeSettings.cinNumber}<br /></>}
                    {storeSettings?.registeredOfficeBisLicense && <>BIS Hallmark License: {storeSettings.registeredOfficeBisLicense}<br /></>}
                    {storeSettings?.registeredOfficeGstin && <>GSTIN: {storeSettings.registeredOfficeGstin}<br /></>}
                    {storeSettings?.registeredOfficeAddress && <>{storeSettings.registeredOfficeAddress}<br /></>}
                  </div>
                </>
              )}

              {/* Android App Download Banner in Footer */}
              {storeSettings?.showAppDownloadBanner && (
                <div style={{
                  backgroundColor: '#0d1b2a',
                  border: '1px solid #ffe500',
                  borderRadius: '6px',
                  padding: '12px',
                  marginTop: storeSettings?.showRegisteredOffice ? '10px' : '0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <Smartphone size={18} color="#ffe500" />
                    <span style={{ fontWeight: 700, color: '#ffffff', fontSize: '13px' }}>
                      {storeSettings?.appDownloadTitle || 'M.L. Jewellers Android App'}
                    </span>
                  </div>
                  <p style={{ color: '#94a3b8', fontSize: '11px', margin: '0 0 10px 0', lineHeight: 1.4 }}>
                    {storeSettings?.appDownloadSubtitle || 'Instant live gold rates, hallmark scanner & zero-wastage calculator on your phone.'}
                  </p>
                  <a
                    href={storeSettings?.appDownloadUrl || '/mljewellers-android.apk'}
                    download="mljewellers-android.apk"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      backgroundColor: '#ffe500',
                      color: '#0d2346',
                      padding: '6px 14px',
                      borderRadius: '4px',
                      fontWeight: 800,
                      fontSize: '11px',
                      textDecoration: 'none',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                    }}
                  >
                    <Download size={13} strokeWidth={2.5} /> {storeSettings?.appDownloadButtonText || 'DOWNLOAD APK (24 MB)'}
                  </a>
                </div>
              )}
            </div>
          )}

        </div>
      </div>

      {/* Flipkart Bottom Bar */}
      <div style={{
        borderTop: '1px solid #454d5e',
        padding: '18px 0',
        backgroundColor: '#172337'
      }}>
        <div className="container" style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          fontSize: '12px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <Link to="/admin" style={{ color: '#ffffff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Briefcase size={14} color="#ffe500" />
              <span>Seller Hub & Admin Desk</span>
            </Link>
            <div style={{ color: '#ffffff', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Award size={14} color="#ffe500" />
              <span>100% BIS Hallmarked</span>
            </div>
            <div style={{ color: '#ffffff', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <Gift size={14} color="#ffe500" />
              <span>Gift Cards</span>
            </div>
            <a
              href="/mljewellers-android.apk"
              download="mljewellers-android.apk"
              style={{ color: '#ffe500', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 700 }}
              title="Download Android APK"
            >
              <Smartphone size={14} color="#ffe500" />
              <span>Download Android App</span>
            </a>
            <Link to="/about" style={{ color: '#ffffff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <HelpCircle size={14} color="#ffe500" />
              <span>Help Center</span>
            </Link>
          </div>

          <div style={{ color: '#878787' }}>
            © 2026 {storeSettings?.storeName || 'mljewellersandkitchenware.com'}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
